import { navigatorLock, type LockFunc } from "@supabase/supabase-js";

export function isInterruptedAuthOperation(error: unknown): boolean {
  return !!error && typeof error === "object" && (
    ("name" in error && error.name === "AbortError") ||
    ("isAcquireTimeout" in error && error.isAcquireTimeout === true)
  );
}

/** Keep cross-tab refresh-token exclusion. Retrying the *acquisition* prevents
 * a brief Safari/Web Lock interruption from permanently rejecting the SDK's
 * cached initialization promise. Never rerun an operation that acquired a lock.
 */
export function recoveringBrowserLock(acquire: LockFunc = navigatorLock): LockFunc {
  return async (name, timeout, operation) => {
    for (let attempt = 0; ; attempt++) {
      let entered = false;
      try {
        return await acquire(name, timeout, async () => {
          entered = true;
          return operation();
        });
      } catch (error) {
        // Zero-timeout calls are background refresh attempts: they should skip
        // when another tab is refreshing, not queue work or steal its lock.
        if (entered || timeout === 0 || attempt >= 2 || !isInterruptedAuthOperation(error)) throw error;
      }
    }
  };
}
